import { useMemo } from 'react'
import {
  formatFakeSalesLabel,
  getFakeSalesCount,
} from 'src/sdk/product/fakeSalesCounter'

type Props = {
  productId?: string
  className?: string
  mode?: 'default' | 'pdp'
}

export default function FakeSalesCounter({
  productId,
  className = '',
  mode = 'default',
}: Props) {
  const salesCount = useMemo(() => {
    if (!productId) {
      return null
    }

    return getFakeSalesCount(productId)
  }, [productId])

  if (!salesCount) {
    return null
  }

  if (mode === 'pdp') {
    return (
      <div
        className={`hidden border-l border-solid border-salesCounterDivider ml-2 mt-2 pl-2 pr-3 flex-1 flex-col items-start justify-center first:ml-0 first:pl-0 first:border-none ${className}`}
        data-testid="fake-sales-counter"
      >
        <p className="desktop-caption-regular font-bold text-restructure-action">
          {formatFakeSalesLabel(salesCount)}
        </p>
      </div>
    )
  }

  return (
    <div
      className={`hidden h-[19px] w-fit my-1 rounded-full bg-salesCounterPill px-3 items-center ${className}`}
      data-testid="fake-sales-counter"
    >
      <p className="text-xs font-bold tracking-[-0.3px] text-restructure-action whitespace-nowrap">
        {formatFakeSalesLabel(salesCount)}
      </p>
    </div>
  )
}
